export default "/images/5f25f53ce9956db68e3ef9a9c74c3f1f.avif";